import {
  ERROR_ORGANIZATION,
  GET_ORGANIZATION_ITEM,
  GET_ORGANIZATIONS,
  GET_ORGANIZATIONS_SEND_REQUEST,
  GET_ORGANIZATIONS_HAS_ROLE,
  GET_ORGANIZATIONS_IS_COURSE_CREATOR,
  GET_ORGANIZATIONS_IS_ADMIN,
  SET_LOADING_ORGANIZATION,
  SET_ORGANIZATION_ITEM,
  UPDATE_DEMAND_ORGANIZATION_ITEM,
  UPDATE_ORGANIZATION_ITEM,
  GET_DEMANDS_ORGANIZATIONS,
  GET_SINGLE_DEMANDS_ORGANIZATIONS,
  GET_SINGLE_ORGANIZATIONS,
  GET_ORGANIZATION_TEACHERS,
  UPDATE_ORGANIZATION_TEACHERS,
} from '../types';
import axiosInstance from '../request';

// Get Approved Organizations
export const getOrganizations = (params = {}) => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    const res = await axiosInstance.get(`/manage/organizations/`, { params });

    const { data } = res;

    dispatch({
      type: GET_ORGANIZATIONS,
      payload: data.results,
    });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

// Get Approved Single Organizations
export const getSingleOrganizations = id => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    const res = await axiosInstance.get(`/manage/organizations/${id}/`);

    const { data } = res;

    dispatch({
      type: GET_SINGLE_ORGANIZATIONS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

// Get All demands about Approving or Unapproving Organizations
export const getOrganizationsDemands = () => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    const res = await axiosInstance.get(`/manage/organizations/demands/registration/`);
    const { data } = res;
    dispatch({
      type: GET_DEMANDS_ORGANIZATIONS,
      payload: data.results,
    });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

// Get Single demands about Approving or Unapproving Organizations
export const getSingleOrganizationsDemands = id => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    const res = await axiosInstance.get(`/manage/organizations/demands/registration/${id}/`);

    const { data } = res;

    dispatch({
      type: GET_SINGLE_DEMANDS_ORGANIZATIONS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

// Get organizations that user can send request
export const getOrganizationsSendRequest = () => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    const res = await axiosInstance.get(`/manage/organizations/all/`);

    const { data } = res;

    dispatch({
      type: GET_ORGANIZATIONS_SEND_REQUEST,
      payload: data.results,
    });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

// Get organizations that user has role in them
export const getOrganizationsHasRole = () => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    const res = await axiosInstance.get(`/organizations/`, {
      params: { user_condition: 'user_has_role_in_them' },
    });
    const { data } = res.data;

    dispatch({
      type: GET_ORGANIZATIONS_HAS_ROLE,
      payload: data.results,
    });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

// Get organizations in which the user is the course creator within it
export const getOrganizationsIsCourseCreator = () => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    const res = await axiosInstance.get(`/organizations/`, {
      params: { user_condition: 'user_has_role_in_them' },
    });
    const { data } = res.data;

    dispatch({
      type: GET_ORGANIZATIONS_IS_COURSE_CREATOR,
      payload: data.results,
    });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

// Get organizations that user is admin or owner(the course creator and admin is both automatically)
export const getOrganizationsIsAdmin = () => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    const res = await axiosInstance.get(`/manage/organizations/`);
    const { data } = res.data;

    dispatch({
      type: GET_ORGANIZATIONS_IS_ADMIN,
      payload: data.results,
    });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

export const getOrganizationItem = id => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    const res = await axiosInstance.get(`/organizations/${id}/`);
    const { data } = res.data;
    dispatch({
      type: GET_ORGANIZATION_ITEM,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

// create organization
export const setOrganizationItem = data => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    await axiosInstance.post(`/manage/organizations/demands/registration/`, data);
    dispatch({ type: SET_ORGANIZATION_ITEM });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

export const updateDemandOrganizationItem = (data, id) => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    await axiosInstance.patch(`/manage/organizations/demands/registration/${id}/`, data);

    dispatch({ type: UPDATE_DEMAND_ORGANIZATION_ITEM });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

export const updateOrganizationItem = (data, id) => async dispatch => {
  try {
    dispatch({ type: SET_LOADING_ORGANIZATION });

    await axiosInstance.patch(`/manage/organizations/${id}/`, data);

    dispatch({ type: UPDATE_ORGANIZATION_ITEM });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};

// Get organization instructors list
export const getOrganizationTeachers = () => async dispatch => {
  try {
    // dispatch({type: GET_ORGANIZATION_TEACHERS});

    const res = await axiosInstance.get('/manage/organization/instructor-connections/');
    const { data } = res;

    dispatch({ type: GET_ORGANIZATION_TEACHERS, payload: data });
  } catch (e) {
    dispatch({
      type: ERROR_ORGANIZATION,
      payload: e.response,
    });
  }
};
